import React from 'react';

export default function TrainingTextEditor({ value, onChange, rows = 8 }) {
  return (
    <div className="form-group">
      <label className="form-label">Contenido</label>
      <textarea
        className="form-control"
        rows={rows}
        value={value || ''}
        onChange={(e) => onChange({ body: e.target.value })}
        placeholder="Escribe el contenido de texto..."
      />
      <small className="text-muted mt-1 d-block">
        Usa <code>**palabra**</code> para resaltar palabras en negrita.
      </small>
    </div>
  );
}
